import { DIDStorage } from './didStorage.type';
import { DIDGenerator } from './didGenerator.type';

export const getDeviceId = async (storage: DIDStorage, generator: DIDGenerator) => {
  let id = await storage.get();
  if (!id) {
    id = await generator();
    await storage.set(id);
  }
  return id;
};
